export default {

    // Games
    game: null,
    games: [],

    // Blockheads
    blockHeads: [],
    userBlockHeads: [],

    // Users
    users: [],

    // User interface
    address: null,
    modalType: '',
    loading: true,
    hasExtension: true,
    pendingTransaction: false,
    locale: 'en',
    hasError: {
        status: false,
        message: null
    },

    // Content loading
    loadingUsers: false,
    loadingBlockWars: false,
    loadingBlockHeads: false

};


// WEBPACK FOOTER //
// ./src/store/state.js